"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageLinkEditor = void 0;
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var VoidLinkComponent_1 = __importDefault(require("Project/QwilrEditor/Widgets/VoidLinkComponent/VoidLinkComponent"));
var ImageLinkEditor = (function (_super) {
    __extends(ImageLinkEditor, _super);
    function ImageLinkEditor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImageLinkEditor.prototype.render = function () {
        var style = { left: "".concat(this.props.leftPosition, "px") };
        if (this.props.leftPosition === 0) {
            style.right = "0px";
        }
        else {
            style.right = "unset";
        }
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)("image-widget__image-controls-holder", "image-widget__image-controls-holder--show-menu"), ref: this.props.menuElemRef, style: style, "data-slate-editor": true, contentEditable: false },
            react_1.default.createElement(VoidLinkComponent_1.default, { updateLink: this.props.updateLink, href: this.props.href, isOpen: true, open: function () { }, close: this.props.closeLinkInput })));
    };
    ImageLinkEditor = __decorate([
        mobx_react_1.observer
    ], ImageLinkEditor);
    return ImageLinkEditor;
}(react_1.default.Component));
exports.ImageLinkEditor = ImageLinkEditor;
